import React from 'react'

import { components } from 'react-select'

import { Icon } from '_components/icon'
import { palette } from '_styles/variables'

export const MultiValueRemove: typeof components.MultiValueRemove = props => (
  <components.MultiValueRemove {...props}>
    <Icon icon="x-circle" size="1rem" color={palette.neutral['grey-bbbdbf']} />
  </components.MultiValueRemove>
)
